/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Configure_Hub_Dataroom_Subtitle2Inputs */

const en_coinvestments_configure_hub_dataroom_subtitle2 = /** @type {(inputs: Coinvestments_Configure_Hub_Dataroom_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure dataroom for this deal`)
};

/**
* | output |
* | --- |
* | "Configure dataroom for this deal" |
*
* @param {Coinvestments_Configure_Hub_Dataroom_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_configure_hub_dataroom_subtitle2 = /** @type {((inputs?: Coinvestments_Configure_Hub_Dataroom_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Configure_Hub_Dataroom_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_configure_hub_dataroom_subtitle2(inputs)
});
export { coinvestments_configure_hub_dataroom_subtitle2 as "coInvestments_configure_hub_dataRoom_subtitle" }